/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from "../runtime";
/**
 * Check if a given object implements the InviteCode interface.
 */
export function instanceOfInviteCode(value) {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    return isInstance;
}
export function InviteCodeFromJSON(json) {
    return InviteCodeFromJSONTyped(json, false);
}
export function InviteCodeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        code: json.code,
        usedBy: !exists(json, "usedBy") ? undefined : json.usedBy,
    };
}
export function InviteCodeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        code: value.code,
        usedBy: value.usedBy,
    };
}
